/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsBulkActionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns void
     * @throws ApiError
     */
    public bulkMigrateFeatureFlag({
        feature,
        requestBody
    }: {
        /**
         * Feature ID
         */
        feature: number
        requestBody?: {
            organizations?: Array<number>
            /**
             * Action to perform on the feature flag.
             */
            action?: 'migrate' | 'retire'
        }
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/bulk-organization-dispatch/migrate-feature-flag/{feature}',
            path: {
                feature: feature
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Sync THub Feature Flags for the organizations.
     * @returns void
     * @throws ApiError
     */
    public bulkSyncThubFeatureFlag({
        requestBody
    }: {
        requestBody?: {
            organizations: Array<number>
        }
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/bulk-organization-dispatch/sync-thub-feature-flag',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Enable or disable a feature flag for a set of organizations at once.
     * @returns void
     * @throws ApiError
     */
    public bulkToggleFeatureFlag({
        feature,
        requestBody
    }: {
        /**
         * Feature ID
         */
        feature: number
        requestBody?: {
            organizations: Array<number>
            /**
             * Whether the feature should be enabled or disabled for the given organizations.
             */
            enabled: boolean | null
        }
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/bulk-organization-dispatch/toggle-feature-flag/{feature}',
            path: {
                feature: feature
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
